export const firebaseFrontendConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID || process.env.NEXT_PUBLIC_FIREBASE_APP_ID
};

export const missingFirebaseConfig = Object.entries(firebaseFrontendConfig)
  .filter(([, value]) => !value)
  .map(([key]) => key);

export const hasFirebaseFrontendConfig = missingFirebaseConfig.length === 0;

const maintenancePageFlag =
  process.env.REACT_APP_ENABLE_MAINTENANCE_PAGE ??
  process.env.REACT_APP_MAINTENANCE_MODE ??
  process.env.NEXT_PUBLIC_ENABLE_MAINTENANCE_PAGE ??
  'false';

export const isMaintenancePageEnabled = String(maintenancePageFlag).trim().toLowerCase() === 'true';
